import React, { useState, useEffect } from "react";
import InvoiceListTable from "../../components/InvoiceListTable";
import InvoiceCard from "../../components/InvoiceCard";
import axios from "axios";

import { getToken, URL } from "../../utils";

export const Facture = () => {
  const [data, setData] = useState([]);
  const [magasinId, setMagasinId] = useState(null);
  const [isCaissier, setIsCaissier] = useState(false);
  const [loadingUser, setLoadingUser] = useState(true);

  const token = getToken();

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const response = await axios.get(URL + `authentification/user-info`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status !== 200) {
          throw new Error(
            "Erreur lors de la récupération des informations utilisateur"
          );
        }

        setMagasinId(response.data.magasin_id);
        setIsCaissier(response.data.is_caissier);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des informations utilisateur :",
          error
        );
      } finally {
        setLoadingUser(false);
      }
    };

    getUserInfo();
  }, [token]);

  useEffect(() => {
    if (loadingUser) return;

    const fetchData = async () => {
      try {
        const url = magasinId
          ? URL + `/Declarations/ventes/liste-ventes/${magasinId}`
          : URL + `/Declarations/ventes/liste-ventes-all`;

        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        setData(response.data);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, [magasinId, token, loadingUser]); // Ajout de loadingUser pour éviter les appels avant que l'utilisateur ne soit chargé

  const transformedData = data
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .map((item) => ({
      ...item,
      on_gozem: item.on_gozem === true ? "Oui" : "Non",
      lieu_conso: item.lieu_conso === "on_place" ? "Sur place" : "Emporté",
    }));

  if (loadingUser) {
    return (
      <div className="flex justify-center items-center h-40 text-lg font-semibold">
        Chargement ...
      </div>
    );
  }

  return (
    <div className="p-4 w-full mx-auto mt-4 ML6' mr-4 bg-white shadow-md rounded-md h-full md:h-auto">
      {!isCaissier && <InvoiceCard />}
      <InvoiceListTable invoiceData={transformedData} />
    </div>
  );
};
